import promiseOver from './promise-over'
export default promiseOver
